export default "__VITE_ASSET__t9EY4vqw__"